import { AssetType } from '@zattoo/playback-sdk';
export const assetIdFromRequestInfo = (requestInfo) => {
    switch (requestInfo.assetType) {
        case AssetType.LIVE:
            return requestInfo.watchRequestParams.cid;
        case AssetType.RECORDING:
            return String(requestInfo.watchRequestParams.recording_id);
        case AssetType.REPLAY:
            return String(requestInfo.watchRequestParams.program_id);
        case AssetType.VOD:
            return requestInfo.watchRequestParams.term_token;
        case AssetType.VOD_TRAILER:
            return requestInfo.watchRequestParams.teasable_id;
        case AssetType.REGISTERED_TIMESHIFT:
            return requestInfo.watchRequestParams.cid;
        default:
            return '';
    }
};
